'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var Spellbook = require('../abstract/spellbook');
function renameSelectExpr(spell) {
    var e_1, _a, e_2, _b, e_3, _c;
    var Model = spell.Model, columns = spell.columns, joins = spell.joins, groups = spell.groups;
    var whitelist = new Set();
    try {
        for (var columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
            var token = columns_1_1.value;
            if (token.type == 'id') {
                if (!token.qualifiers && Model.columnAttributes[token.value]) {
                    token.qualifiers = [Model.tableAlias];
                }
                whitelist.add(token.qualifiers[0]);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var _d = __values([Model.tableAlias].concat(Object.keys(joins))), _e = _d.next(); !_e.done; _e = _d.next()) {
            var qualifier = _e.value;
            if (!whitelist.has(qualifier) && !groups.length > 0) {
                var model = qualifier == Model.tableAlias ? Model : joins[qualifier].Model;
                try {
                    for (var _f = (e_3 = void 0, __values(model.columns)), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var definition = _g.value;
                        var value = definition.columnName;
                        columns.push({ type: 'id', qualifiers: [qualifier], value: value });
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        }
        finally { if (e_2) throw e_2.error; }
    }
    for (var i = 0; i < columns.length; i++) {
        var token = columns[i];
        var type = token.type, qualifiers = token.qualifiers, value = token.value;
        if (!qualifiers)
            continue;
        var qualifier = qualifiers[0];
        if (type == 'id') {
            columns[i] = {
                type: 'alias',
                value: "".concat(qualifier, ":").concat(value),
                args: [token],
            };
        }
    }
}
var SQLiteSpellBook = /** @class */ (function (_super) {
    __extends(SQLiteSpellBook, _super);
    function SQLiteSpellBook() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SQLiteSpellBook.prototype.formatSelect = function (spell) {
        if (Object.keys(spell.joins).length > 0) {
            spell = spell.dup;
            renameSelectExpr(spell);
        }
        return _super.prototype.formatSelect.call(this, spell);
    };
    return SQLiteSpellBook;
}(Spellbook));
module.exports = SQLiteSpellBook;
//# sourceMappingURL=spellbook.js.map